export const BRAND = {
  name: 'maaliondoor',
  logoSrc: '/images/logo.png',
  logoAlt: 'maaliondoor — Flowers, Plants & Giftings',
  logoWidth: 230,
  logoHeight: 60,
} as const

export type BrandLogoProps = {
  to?: string
}
